
      import DownloadCircle from './download-circle.vue'
      import type { App, Plugin } from 'vue'

      export const DownloadCirclePlugin: Plugin = {
        install(app: App) {
          app.component('DownloadCircle', DownloadCircle)
        },
      }
      export { DownloadCircle }
      